import React, { useCallback } from "react";

import classNames from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";

import { LazyImage } from "../LazyImage";
import * as styles from "./RCAImage.module.scss";

interface RCAImageProps {
  image?: string | {};
  cloudinaryImage?: {};
  alt: string;
  title?: string;
  fluidOverrides?: object;
  imageClassName?: string;
  containerClassName?: string;
  noBorder?: boolean;
  className?: string;
  props?: object;
}

const RCAImage: React.FC<RCAImageProps> = ({
  image,
  cloudinaryImage,
  alt,
  title,
  fluidOverrides = {},
  imageClassName,
  containerClassName,
  noBorder = false,
  className,
  ...props
}) => {
  // const borderWidth = useResponsiveValue(theme.sizes.borderWidth)

  const sanitizedAlt =
    alt && alt.startsWith("http://") ? alt.substring(7) : alt;

  const onLoad = useCallback(() => {
    window.dispatchEvent(
      new Event("tile-loaded", {
        bubbles: true,
      }),
    );
  }, []);

  return (
    <div
      className={classNames(
        styles.outer,
        { [styles.noBorder]: noBorder, [styles.hasImage]: !!image },
        className,
      )}
      {...props}
    >
      {" "}
      <div className={styles.curtain} />
      <div className={classNames(styles.container, containerClassName)}>
        {image && typeof image === "string" && (
          <LazyImage
            src={image}
            alt={sanitizedAlt}
            title={title}
            className={classNames(imageClassName)}
          />
        )}
        {image && typeof image !== "string" && (
          <GatsbyImage
            image={image}
            className={classNames(imageClassName)}
            alt={sanitizedAlt}
            title={title}
            onLoad={onLoad}
            loading="lazy"
          />
        )}
        {cloudinaryImage && (
          <GatsbyImage
            // TO FIX!
            // previously we passed fluidOverrides to the image
            // perhaps we should pass it to the GatsbyImage somehow?
            // image={{ cloudinaryImage, ...fluidOverrides }}
            image={cloudinaryImage}
            className={classNames(imageClassName)}
            alt={sanitizedAlt}
            title={title}
            onLoad={onLoad}
            loading="lazy"
          />
        )}
      </div>
    </div>
  );
};

export { RCAImage };
